export default "__VITE_ASSET__B9TgyZ3S__"